import { PropsWithChildren } from 'react';

import { SSRSafeSuspense } from '@zep/common/react-boundary';
import { PageWithLayout } from '@zep/types';

export function withPageSuspense<
  Props = Record<string, any>,
  InitialProps = Props,
>(
  Page: PageWithLayout<Props, InitialProps>,
  options: {
    fallback?: React.ReactNode;
  } = {
    fallback: null,
  },
) {
  return Object.assign(
    (props: PropsWithChildren<Props>) => (
      <SSRSafeSuspense fallback={options.fallback}>
        <Page {...props} />
      </SSRSafeSuspense>
    ),
    {
      getLayout: Page.getLayout,
    },
  );
}
